import { appRootURL, LoginMethod } from "@/constants";
import { useAuthService } from "@services/authentication";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router";

const SSOCallback = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("code");
  const navigate = useNavigate();
  const { handleLogin } = useAuthService();
  const isProcessing = useRef(false);

  useEffect(() => {
    const processSSO = async () => {
      // Prevent multiple calls
      if (isProcessing.current || !token) {
        return;
      }

      isProcessing.current = true;
      try {
        await handleLogin({
          token,
          redirectUrl: `${appRootURL}/sso-callback`,
          authType: LoginMethod.SSO,
        });

        // Check for stored return URL and redirect to it, otherwise go to "/"
        const returnUrl = localStorage.getItem("returnUrl");
        if (returnUrl) {
          localStorage.removeItem("returnUrl"); // Clean up stored URL
          navigate(returnUrl, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch (_error) {
        console.error("SSO authentication failed");
        isProcessing.current = false; // Reset on error to allow retry
      }
    };

    processSSO();
  }, [token, handleLogin, navigate]);

  return (
    <div className="sso-callback">
      <div>Processing authentication...</div>
    </div>
  );
};

export default SSOCallback;
